import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateUser } from '../state_user';

export const LOCAL__user_auth_set_open_page_after_login = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.USER_AUTH_SET_PAGE_AFTER_LOGIN,
  payload,
});

export function INIT_LOCAL__user_auth_set_open_page_after_login(state: StateUser, action: PayloadAction<string>) {
  if (action.payload !== ENUM__page_type.AUTH) state.open_page_after_auth = action.payload;
}
